<div class="form-group">
  <label [for]="id">{{ title }}</label>
  <input
    *ngIf="type === 'text' || type === 'number'"
    [type]="type"
    [formControl]="control"
    class="form-control"
    [id]="id"
    [placeholder]="placeholder" />
  <textarea
    *ngIf="type === 'textarea'"
    [formControl]="control"
    class="form-control"
    [id]="id"
    [rows]="rows"
    [placeholder]="placeholder"></textarea>
  <div *ngIf="error" class="input_error_text">{{ error }}</div>
</div>
